import React, { useEffect } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Collapse from '@material-ui/core/Collapse'
import M_FieldDateSet from 'components/1_Atoms/2_Molecules/M_FieldDateSetNew'
import M_FieldSelect from 'components/1_Atoms/2_Molecules/M_FieldSelectNew'
import M_ButtonSubmit from 'components/1_Atoms/2_Molecules/M_ButtonSubmit'
import M_FieldJotaiJapell from 'components/1_Atoms/2_Molecules/M_FieldJotaiJapell'
import { organismGroupLog } from 'utils/logUtil'
import { convertNumber } from 'utils/numberUtil'
import { baseInfo } from 'types/SearchTypes'
import { getTimestampFromNumber } from 'utils/dateUtil'
import { useAddTanto, useDate, useJigyosho, useSearch, useShiiresaki, useShohin, useTokuisaki } from 'hooks/useRitsuJoken'
import { useQuery } from 'react-query'
import { getFetchString } from 'utils/stringUtil'

const manualMode = process.env.REACT_APP_MANUAL_MODE === '1'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    grid: {
      flexGrow: 1,
    },
    box: {
      textAlign: 'left',
    },
    impotant: {
      color: '#FF0000',
    },
    entered: {
      width: '100%',
    },
  }),
)

type Props = {
  info: baseInfo
}

const O_SearchBox = ({ info }: Props) => {
  useEffect(() => organismGroupLog('O_SearchBox'))
  const classes = useStyles()

  const [SYORI_YM_START, SYORI_YM_END, changeStartDt, changeEndDt] = useDate()
  const [SIIRE_CD, changeSiire] = useShiiresaki()
  const [TOKUI_CD, changeTokui] = useTokuisaki()
  const [JIGYO_CD, changeJigyo] = useJigyosho()
  const [ADD_TANTO_CD, changeAddTanto] = useAddTanto()
  const [mishonin, shonin, _hinin, jochoShonin, jochoMishonin, hininMikakunin, jochoHininMikakunin, hininkakuninzumi, _, changeMishonin, changeShonin, _changeHinin, changeJochoShonin, changeJochoMishonin, changeHininMikakunin, changeJochoHininMikakunin, changeHininkakuninzumi, __] = useShohin()
  const [clickReset, ___, fetcher] = useSearch()

  // 検索条件初期化ボタンの文言を取得
  const { data, isFetching, isLoading, error } = useQuery(['postResetButtonWordJapell', []], fetcher)
  const resetButton = getFetchString(error, isFetching, isLoading, data)

  return (
    <Collapse in={true} timeout="auto" className={classes.entered}>
      <Grid container spacing={1}>
        {/* //////////////////// 1 行目 //////////////////// */}
        <Grid item xs={12} sm={4} className={classes.root}>
          {/* ==== 年月 ==== */}
          <M_FieldDateSet
            key1={1} //
            value1={getTimestampFromNumber(convertNumber(SYORI_YM_START, 6))}
            blurFunc1={changeStartDt}
            focus={false}
            disabled1={false}
            key2={2}
            value2={getTimestampFromNumber(convertNumber(SYORI_YM_END, 6))}
            blurFunc2={changeEndDt}
            disabled2={false}
          />
        </Grid>
        <Grid item xs={12} sm={4} className={classes.root}>
          {/* ==== 仕入先 ==== */}
          <M_FieldSelect //
            label="仕入先"
            valueCode={SIIRE_CD}
            valueSet={info.siireList}
            event={changeSiire}
            blackout={manualMode}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          {/* ==== 入力担当者 ==== */}
          <M_FieldSelect //
            label="入力担当者"
            valueCode={ADD_TANTO_CD}
            valueSet={info.addTantoList}
            event={changeAddTanto}
            blackout={manualMode}
          />
        </Grid>

        {/* //////////////////// 2 行目 //////////////////// */}
        <Grid item xs={12} sm={4} className={classes.root}>
          {/* ==== 得意先 ==== */}
          <M_FieldSelect //
            label="得意先"
            valueCode={TOKUI_CD}
            valueSet={info.tokuiList}
            event={changeTokui}
            blackout={manualMode}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          {/* ==== 事業所 ==== */}
          <M_FieldSelect //
            label="事業所"
            valueCode={JIGYO_CD}
            valueSet={info.jigyoList}
            event={changeJigyo}
            blackout={manualMode}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          {/* -------- [ 確認対象表示ボタン ] -------- */}
          <Grid container justify="flex-end">
            <M_ButtonSubmit label={resetButton} event={clickReset} disabled={false} />
          </Grid>
        </Grid>

        {/* //////////////////// 3 行目 //////////////////// */}
        <Grid item xs={12} sm={8} className={classes.grid}>
          {/* ==== 状態 ==== */}
          <M_FieldJotaiJapell
            label1={'仕入先承認状態'} //
            label2={'上長承認状態'} //
            check1={mishonin}
            check2={shonin}
            check3={hininMikakunin}
            check4={hininkakuninzumi}
            check5={jochoMishonin}
            check6={jochoHininMikakunin}
            // check7={jochoHininKakuninzumi} //
            check8={jochoShonin}
            event1={changeMishonin}
            event2={changeShonin}
            event3={changeHininMikakunin}
            event4={changeHininkakuninzumi}
            event5={changeJochoMishonin}
            event6={changeJochoHininMikakunin}
            // event7={changeJochoHininkakuninzumi}
            event8={changeJochoShonin}
            disabled={false}
          />
        </Grid>
        <Grid item xs={12} sm={4}></Grid>
      </Grid>
    </Collapse>
  )
}
export default React.memo(O_SearchBox)
